import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Terminal from "./views/Terminal";
import NotFound from "./views/NotFound";
import { LanguageProvider } from "./context/LanguageContext";

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Terminal />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
